module.exports = __webpack_public_path__ + "static/media/September_2026_2.4f0a9d57.webp";